import * as React from 'react';
import { Button, ButtonProps } from "../Button";

type DownloadButtonProps = Omit<ButtonProps, "buttonType">;

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  onClick: providedOnClick,
  ...buttonProps
}) => {
  const onClick = (e: React.MouseEvent): void => {
    analytics.track("Download Button Clicked");
    if (providedOnClick) providedOnClick(e);
  }
  return (
    <Button {...buttonProps} onClick={onClick} {...buttonProps}/>
  )
};
